import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { CampaignType, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { campaignTypeFilter, filterMapItem } from './processor-helpers';

const defaultCampaign = { CampaignType: CampaignType.All };


const filterMapItemByCampaign = (siteMap, permissions, campaignId, currentCampaign) => {
  const campaignFilter = (campaign, item) =>
    campaignTypeFilter(_.result(CampaignType, campaign.CampaignType, CampaignType.All), item, permissions) && // eslint-disable-line
    (!campaignId || !_.isFunction(item.currentCampaign) ||
      item.currentCampaign(campaign === defaultCampaign ? null : campaign, permissions));

  return filterMapItem(
    siteMap,
    _.partial(campaignFilter, currentCampaign),
    permissions
  );
};

const filterMapItemByCampaignCached = memoize(filterMapItemByCampaign);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processCampaignId(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const {
      scope: { values: { campaignId } },
      permissions,
    } = props;

    const processor = campaign => (<Component
      {...props}
      siteMap={filterMapItemByCampaignCached(siteMap, permissions, campaignId, campaign)}
    />);

    return (
      <CampaignOData
        call={({ currentCampaign }) => currentCampaign.get()}
        escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : {})}
        fallback={processor(defaultCampaign)}
        onError={() => processor(defaultCampaign)}
        testRef={testRef}
      >
        {campaign => processor(campaign)}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
    permissions: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.objectOf(PropTypes.bool),
      PropTypes.number,
    ])).isRequired,
  };

  return withPermissions(withScope(Wrapper));
}
